import React from 'react';

const Footer = () => (
  <div>
    <footer><p>© 2022 All Right Reserved</p></footer>
  </div>
);

export default Footer;
